export const ChannelType = {
  Telegram: 'TELEGRAM',
  X: 'X',
  Whatsapp: 'WHATSAPP',
  Email: 'EMAIL',
  Website: 'WEBSITE',
} as const;

export type ChannelTypeValue = (typeof ChannelType)[keyof typeof ChannelType];

export interface PostChannelVerificationVerifyParams {
  channel: ChannelTypeValue;
  value: string;
}

export interface PostChannelVerificationVerifyResponse {
  result: boolean;
  enteredChannel: ChannelTypeValue;
  enteredValue: string;
}

export interface PostChannelVerificationReportParams {
  channel: ChannelTypeValue;
  source: string;
  description?: string | null;
}

export type PostChannelVerificationReportResponse = Record<string, never>;
